"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _memoize = _interopRequireDefault(require("lodash/memoize"));

var _default = (0, _memoize.default)(function (key, columns) {
  var firstDataColumn = columns.find(function (_ref) {
    var colKey = _ref.key;
    return !colKey.startsWith('__internal_');
  });
  return key === firstDataColumn.key;
});

exports.default = _default;